<script>
    import Datepicker from 'vuejs-datepicker';
    import {en, es, fr, de, ptBR, zh} from 'vuejs-datepicker/dist/locale'
    import moment from 'moment';
    export default {
        props: ['tour', 'tour_base_price', 'deafult_locales'],
        components: {
            Datepicker
        },
        data() {
            return {
                lang: 'en',
                step: 0,
                logged_in: false,
                form_errors: '',
                total_price: 0,
                base_price: 0,
                addons_price: 0,
                addons: '',
                languages: '',
                loading: false,
                locales: '',
                en: en,
                es: es,
                fr: fr,
                de: de,
                pt: ptBR,
                cn: zh,
                maxAdults: 100,
                maxKids: 100,
                infants_have_price: false,
                days_ahead: 10,
                booking_min_date: '',
                enquiry_min_date: '',
                booking: {
                    tour_id: "",
                    email: "",
                    date: "",
                    adults: 1,
                    kids: 0,
                    infants: 0,
                    first_name: "",
                    surname: "",
                    phone_number: "",
                    additional_info: "",
                    payment_type: "enquiry",
                    addons: [],
                    language: "",
                    terms: false,
                    enquiry: true,
                },
                start_date: moment().add(this.days_ahead+1, 'days').toDate(),
                disabledDates: { 
                    to: moment().add(this.days_ahead, 'days').toDate(),
                },
                highlighted: {
                    // to: moment().add(10, 'days').toDate(),
                    // from: moment().add(10, 'days').toDate(),
                    dates: [],
                    includeDisabled: true
                },
                bankForm: {
                     mid: '',
                     orderid: '',
                     orderAmount: '',
                     orderDesc: '',
                     currency: '',
                     payerEmail: '',
                     confirmUrl: '',
                     cancelUrl: '',
                     lang: '',
                     digest: ''
                }

            }
        },
        created() {
            this.$validator.extend('max_persons', {
                getMessage: (field) => { 
                    return 'Please select '+this.maxAdults+' max persons'; 
                },
                validate: (value) => {
                    if(this.infants_have_price) {
                        if(parseInt(this.booking.adults) + parseInt(this.booking.kids) + parseInt(this.booking.infants) > this.maxAdults) return false;
                    } else {
                        if(parseInt(this.booking.adults) + parseInt(this.booking.kids) > this.maxAdults) return false;
                    }

                    return true;
                }
            })
        },
        mounted() {
            // this.maxAdults = this.tour.max_persons;
            this.days_ahead = this.tour.days_ahead;
            //send booking default
            // this.start_date = moment().add(this.days_ahead+1, 'days').toDate();
            // this.disabledDates.to = moment().add(this.days_ahead, 'days').toDate();
            //send enquiry default
            this.start_date = moment().add(0, 'days').toDate();
            this.disabledDates.to = moment().add(0, 'days').toDate();

            this.booking_min_date = moment().add(this.days_ahead+1, 'days').toDate();
            this.enquiry_min_date = moment().add(0, 'days').toDate();

            this.infants_have_price = this.tour.infants_have_price
            // this.maxAdults = this.tour.tourprices.length; //when default is book now set max adults
            this.lang = document.documentElement.lang;
            this.booking.tour_id = this.tour.id;
            if(this.tour_base_price) {
                this.total_price = this.tour_base_price;
            }
            if(this.total_price == 0) {
                // this.changeType('enquiry')
            }
            if(this.tour.addons) {
                this.logged_in = true;
            }
            if(this.tour.languages) {
                this.languages = this.tour.languages;
            }
            moment.locale(this.lang);
            this.$nextTick(function() {
                window.addEventListener('resize', this.initCalendarCells);
                this.initCalendarCells()
            })
            $('body').on('click', '.vdp-datepicker__calendar .next', (event) => {
                this.initCalendarCells();
            });
            $('body').on('click', '.vdp-datepicker__calendar .prev', (event) => {
                this.initCalendarCells();
            });
            this.locales = this.deafult_locales;
            this.initLocales();
        },
        computed: {
            totalPersons: function () {
                return this.booking.adults + this.booking.kids
            }
        },
        methods: {

            initLocales() {
                let locales_array = [];
                for(let key in this.locales) {
                    var search = this.searchLanguage(this.locales[key]);
                    if(search) {
                        locales_array.push({
                            code: key,
                            language: this.locales[key],
                            object: search
                        });
                    } else {
                        locales_array.push({
                            code: key,
                            language: this.locales[key],
                            object: {
                                id :'',
                                language: null
                            }
                        });
                    }
                }
                this.locales = locales_array;
            },
            onLanguageChange() {
                 if(isNaN(this.booking.language)){
                    this.changeType('enquiry'); 
                    return;
                 }
                this.calculatePrice();
            },

            changeType(type) {
                // if(this.step != 1) return;
                if(type == 'enquiry') {
                    this.$validator.reset();
                    this.booking.enquiry = true;
                    this.booking.payment_type = 'enquiry';
                    this.booking.date = "";
                    this.start_date = moment().add(0, 'days').toDate();
                    this.disabledDates.to = moment().add(0, 'days').toDate();
                    // this.booking.adults = 1;
                    // this.booking.kids = 0;
                    this.maxAdults = 100;
                    this.maxKids = 100;
                    this.step = 1;
                } else {
                    this.$validator.reset();
                    this.booking.enquiry = false;
                    this.booking.payment_type = '';
                    this.booking.date = "";
                    this.start_date = moment().add(this.days_ahead+1, 'days').toDate();
                    this.disabledDates.to = moment().add(this.days_ahead, 'days').toDate();
                    // this.booking.adults = 1;
                    // this.booking.kids = 0;
                    if(this.booking.adults > this.tour.max_persons) {
                        this.booking.adults = this.tour.max_persons;
                    }
                    this.step = 1;
                    this.maxAdults = this.tour.max_persons;
                    this.maxKids = this.tour.max_persons;
                    this.booking.language = "";
                    if(this.tour.languages.length == 1) {
                        console.log(this.tour.languages[0].id);
                        this.booking.language = this.tour.languages[0].id;
                    }
                    this.calculatePrice();
                }
                this.calculateHighlightedDates();
            },

            checkIfEnquiry() {
                this.$nextTick(function() {
                    let diff_days = moment().diff( this.booking.date, 'days'); 
                    if(diff_days > -10) {
                        this.booking.enquiry = true;
                        this.booking.payment_type = 'pay_later';
                    } else {
                        this.booking.enquiry = false;
                        this.booking.payment_type = '';
                    }
                });
            },

            calculateHighlightedDates() {
                if(this.booking.enquiry) {
                    this.highlighted.dates = [];
                    return;
                }
                let first_date =  moment();
                let last_date = moment().add(this.days_ahead-1, 'days');
                while (first_date.isSameOrBefore(last_date)) {
                    first_date.add(1, 'days');
                    this.highlighted.dates.push(first_date.toDate());
                }
                  this.$nextTick(()=>{
                    document.querySelectorAll('.highlighted').forEach(button => {
                    button.addEventListener('click', () => {
                        this.changeType('enquiry');
                    }, false);
                    });
                })
            },

            initCalendarCells(event) {
                let width = $('.cell.day').outerWidth();
                $('.cell.day').css({
                    height: width+'px',
                    lineHeight: width-4+'px',
                });
                var total_days = 42;
                $('.cell.is-empty').remove();
                var days_on_month = $('.vdp-datepicker__calendar > div span').length;
                var days_diff = total_days - days_on_month;
                var emptyCells;
                if(days_diff > 0 && days_diff < 6) {
                    emptyCells = [];
                    for(var i=0; i<days_diff; i++) {
                        emptyCells.push($('<span>', {
                            class: 'cell is-empty'
                        }));
                        $('.vdp-datepicker__calendar > div').append(emptyCells);
                    }
                }
                if(days_diff == -1) {
                    emptyCells = [];
                    for(var i=0; i<6; i++) {
                        emptyCells.push($('<span>', {
                            class: 'cell is-empty'
                        }));
                        $('.vdp-datepicker__calendar > div').append(emptyCells);
                    }
                }
            },

            submitForm(scope) {
                this.$validator.validateAll(scope).then(result => {
                    
                    if (result) {
                        if(this.step == 6) {
                            console.log('make the payment!');
                            this.placeOrder();
                            return;
                        }
                        this.loading = true;
                        axios.post('/tours/calculate-price', this.booking, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                        })
                        .then( response => {
                            this.total_price = response.data.total_price;
                            this.base_price = response.data.base_price;
                            this.addons_price = response.data.addons_price;
                            this.nextStep();
                            this.loading = false;
                        })  
                        .catch( e => { 
                            this.loading = false;
                            console.log(e.response.data);
                            if(e.response.data.errors) {
                                this.form_errors = e.response.data.errors
                            }
                        });
                    }
                });
            },
            nextStep() {
                this.step++;
                if(!this.logged_in && this.step == 4) {
                    this.step++;
                }
                if(this.step == 2) {
                    this.$nextTick(function() {
                        this.initCalendarCells();
                    });
                }
            },
            calculatePrice() {
                if(this.booking.enquiry) {return}
                this.loading = true;
                axios.post('/tours/calculate-price', this.booking, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                .then( response => {
                    this.loading = false;
                    if(response.data.total_price == null) return;
                    this.total_price = response.data.total_price;
                    this.base_price = response.data.base_price;
                    this.addons_price = response.data.addons_price;
                    
                })  
                .catch( e => { 
                    console.log(e.response.data);
                    this.loading = false;
                    if(e.response.data.errors) {
                        this.form_errors = e.response.data.errors
                    }
                });
            },
            placeOrder() {
                this.form_errors = "";
                this.loading = true;
                axios.put('/'+this.lang+'/order', this.booking, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                .then( response => {
                    // this.loading = false;
                    if(response.data.payment_type == "credit_card") {
                        this.$ga.event({
                            eventCategory: 'Booking Form',
                            eventAction: 'New Booking',
                            eventLabel: response.data.tour_title,
                            eventValue: 1
                        });
                        this.bankForm = response.data.form_data;
                        this.$nextTick(function() {
                            this.$refs.bank_form.submit();
                        });
                    } else if(response.data.payment_type == "pay_later") {
                        console.log(response.data)
                        var order_id = response.data.order_id;
                        this.loading = false;
                        // alert(order_id); //redirect to payment success page
                    }
                     else if(response.data.payment_type == "enquiry") {
                         this.$ga.event({
                            eventCategory: 'Booking Form',
                            eventAction: 'New Enquiry',
                            eventLabel: response.data.tour_title,
                            eventValue: 1
                        });
                        var order_id = response.data.order_id;
                        // this.loading = false;
                        window.location.href = response.data.redirect_url;
                    }
                })  
                .catch( e => { 
                    this.loading = false;
                    console.log(e.response.data);
                    if(e.response.data.errors) {
                        this.form_errors = e.response.data.errors
                    }
                });
            },
            goBack(){
                if(this.step >= 1){
                    this.step--
                    if(!this.logged_in && this.step == 4) { 
                        this.step--;
                    }
                }
            },
            searchLanguage(nameKey){
                let itemYouWant = null;
                this.tour.languages.forEach((item) => {
                    if (item.language == nameKey) {
                        itemYouWant = item;
                    }
                });
                return itemYouWant
            }
        },
        filters: {
            formatDate: function (value) {
                if (!value) return ''
                return moment(String(value)).format('dddd, MMMM D, YYYY')
            },
            formatDateShort: function (value) {
                if (!value) return ''
                return moment(String(value)).format('MMM D, YYYY')
            }
        }
    }
</script>
<style lang="scss">
    .vdp-datepicker__calendar .cell.selected {
        background: #FFC500;
    }
    .vdp-datepicker__calendar .cell.selected:hover {
         background: #FFC500;   
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year { 
        border: 2px solid #FFC500;
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 2px solid #FFC500;
        background: #FFC500;   
    }
    .vdp-datepicker__calendar .cell.highlighted { 
        border: 2px dashed #D4DFEE!important;
        color: #072646!important;
        cursor: pointer;
        &:after {
            display:none;
        }
        &:before {
            content: "Send Enquiry";
            font-size: 0.7em;
            line-height: 1em;
            width:100px;
            left: 50%;
            transform: translateX(-50%);
            border: 2px solid #95AAB9!important;
            position: absolute;
            top: -25px;
            padding: 5px;
            background: #fff;
            display: none;
        }
        &:hover {
            &:before {
                display: block;
            }
        }
    }
    .vdp-datepicker__calendar .cell.today {
        border: 2px solid #D4DFEE!important;
        background: #D4DFEE!important;
        font-weight: 700;
        color: #072646;
        &:after {
            display:none;
        }

    }
    .number-input {
        input {
            border-radius: 0!important;
            border-color: #B1C2DB!important;
            width: 90px!important;
            height: 30px!important;
            padding-left: 30px!important;
            padding-right: 30px!important;
            text-align: center;
            color: #072646;
            font-weight: 600;
            font-family: 'Poppins';
            &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
                -webkit-appearance: none!important;
            }
            -moz-appearance:textfield;
        }
        &__button {
            border-radius: 0!important;
            border-color: #B1C2DB!important;
            width: 30px!important;
            height: 28px!important;
            &:before, &:after {
                background-color: #59656E!important;
            }
        }
    }
    .vdp-datepicker__calendar {
        border-color: #D4DFEE!important;
    }
    .vdp-datepicker__calendar .cell.highlighted, {
        
    }
     .vdp-datepicker__calendar .cell.disabled, .vdp-datepicker__calendar .cell.blank {
         background: none;
        border: none;
     }
     .vdp-datepicker__calendar .cell.disabled {
         position: relative;
         &:after {
             content: "";
             position: absolute;
             width: 100%;
             top: 50%;
             left: 0;
             transform: translateY(-50%) rotate(-45deg);
             height: 1px;
             background: #D4DFEE;
             margin-left:-2px;
         }
     }
    .vdp-datepicker__calendar .cell.highlighted {
        background: none;
        // border: none!important;
    }
    .vdp-datepicker__calendar .cell {
    }
    .vdp-datepicker__calendar {
        > div {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            // justify-content: space-around;
            justify-content: flex-start;
            border-top: 1px dashed #072646;
                padding-bottom: 5px;
        }
        .cell.day {
            // margin: 4px 4px;
            margin: 4px 6px 4px 5px;
            border-width: 2px;
            height: unset;
            line-height: unset;
            border-radius: 50%;
            width: calc(100% * (1/7) - 10px - 1px);
            font-size: 0.9em;
            // min-width: 50px;
            // border: 2px solid #FFC500;
            &.selected {
                font-weight: 700;
                // border-color: #FFC500;
            }
            &.highlighted {
                // border-color: #D4DFEE!important;
                &:hover {
                    // background: #D4DFEE!important;
                    // border-color: #D4DFEE!important;
                }
            }
        }
        .cell.selected.highlighted {
            background: #D4DFEE!important;   
        }
        header {
            .day__month_btn {
                font-weight: 600;
            }
        }
    }
</style>
